import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-title-config',
  templateUrl: './d-title-config.component.html',
  styles: []
})
export class DTitleConfigComponent extends DynamicComponentBase {
  static KEY = 'd-title-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}

  // changeComplete(v) {
  //   console.log(v);
  // }
}
